export default "__VITE_ASSET__XTFJKbBI__"